var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.device && _vm.device.serialNumber)?_c('LiveVideo',{ref:"liveVideo",attrs:{"device":_vm.device,"ipcVideo":_vm.deviceProp.helpType ? true : false},on:{"close":_vm.closeVideo,"handleVideo":_vm.handleVideo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }